<template>
  <div class="wrap">
    <h3 class="title">佳佳乐用户服务协议</h3>
    <p>欢迎您使用佳佳乐的服务！</p>
    <p>为使用佳佳乐的服务，您应当阅读并遵守本《佳佳乐用户服务协议》（以下简称“本协议”）。本协议是用户与佳佳乐之间的法律协议，是用户注册佳佳乐账号并使用佳佳乐APP服务时的通用条款。请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任的条款、管辖与法律适用条款。限制、免责条款可能以黑体加粗或加下划线的形式提示您重点注意。除非您已阅读并接受本协议所有条款，否则您无权使用佳佳乐提供的服务。您使用佳佳乐的服务即视为您已阅读并同意本协议的约束。</p>
    <p>一、定义</p>
    <p>佳佳乐APP，是指北京佳付通网络科技有限公司旗下运营之佳佳乐移动应用软件，为用户提供的手机客户端软件，为客户提供安全、便捷、高效的平台服务。</p>
    <p>用户，以下亦称为“您”。注册用户是指通过佳佳乐APP完成全部注册程序后，使用佳佳乐APP服务的用户。</p>
    <p>二、协议的效力</p>
    <p>1、在您按照注册页面提示填写信息、完成全部注册程序后，即视为您对本协议的接受，并同意接受本协议各项条款的约束。</p>
    <p>2、本协议内容包括本协议正文，您在使用佳佳乐某一特定服务时，该服务可能会另有单独的协议、相关业务规则、公告、帮助、说明、通用条款等（以下统称为“规则”）。所有佳佳乐已经发布的或将来可能发布的规则均为本协议不可分割的组成部分，与本协议具有同等法律效力。除另行明确声明外，任何佳佳乐提供的服务（以下称为“佳佳乐APP服务”）均受本协议约束。您承诺接受并遵守本协议的约定。如果您不同意本协议的约定，您应立即停止注册程序或停止使用佳佳乐APP服务；如您继续注册和使用佳佳乐APP服务，即视为您已确知并完全同意本协议各项内容。</p>
    <p>3、佳佳乐有权根据国家法律法规的更新和服务规则的调整需要不时地制订、修改本协议及/或各类规则，并以APP公示的方式进行公示，不再另行通知。如您继续使用佳佳乐APP服务的，即表示您接受经修订的协议和规则。如发生有关争议时，以佳佳乐最新的相关协议和规则为准。</p>
    <p>三、注册及账号管理</p>
    <p>1、您确认，在您完成注册程序或以其他方式实际使用佳佳乐APP服务时，您应当是具备相应民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的家长或法定监护人（以下统称'监护人'）应承担因此而导致的一切后果，且佳佳乐有权注销您的账户，并向您及您的监护人索偿。</p>
    <p>2、在您签署本协议，完成注册程序时，佳佳乐会向您提供唯一编号的佳佳乐账户。您应对您的用户账户、登录密码、支付密码（如有）、验证码的安全，以及对通过您的账户和密码实施的行为负责；因此所衍生的任何损失或损害，佳佳乐无法也不承担任何责任。除非有法律规定或行政司法机关的指令，且征得佳佳乐的同意，否则您的用户账户、登录密码、支付密码（如有）和验证码不得以任何方式转让、借用、赠与或继承（与账户相关的财产权益除外）。否则，由此给您（或佳佳乐、任何第三方）造成的一切损失，概由您自行承担（或者负责赔偿）。</p>
    <p>3、如果发现任何人不当使用您的账户或有任何其他可能危及您的账户安全的情形时，您应当立即以有效方式通知佳佳乐，要求佳佳乐暂停相关服务。您理解佳佳乐对您的请求采取行动需要合理时间，佳佳乐对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。</p>
    <p>4、您在注册帐号或使用佳佳乐APP服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写您的真实的身份信息及有效联系方式。若您填写的信息不完整，则无法使用佳佳乐APP服务或在使用过程中受到限制。</p>
    <p>5、您了解并同意，如您符合并且遵守本协议条款，在通过佳佳乐APP完成注册程序之后，即可成为佳佳乐APP用户。对于您主动提交的相关信息，您授权佳佳乐及/或佳佳乐网站运营者及关联服务提供方委托的第三方通过合法渠道（包括但不限于征信机构等）了解、咨询、审查您的操作风险的真实情况，并据此判断您的风险状况。</p>
    <p>6、您了解并同意，一经注册用户账号或者使用佳佳乐APP服务，即视为您同意佳佳乐及/或其关联公司通过短信、电话或者电子邮件的方式向您注册时填写的手机号码或者电子邮箱发送相应的 服务广告信息、促销优惠等营销信息或为您提供任何您可能感兴趣的信息；您如果不同意发送，您可以通过相应的退订功能进行退订。</p>
    <p>7、您在使用佳佳乐服务过程中，所产生的应纳税赋，以及一切硬件、软件、服务及其它方面的费用，均由您独自承担。</p>
    <p>8、佳佳乐有权根据用户资信情况，决定是否受理用户的注册申请。</p>
    <p>四、佳佳乐权利义务</p>
    <p>1、佳佳乐通过佳佳乐APP为您提供安全、便捷、高效的平台服务。</p>
    <p>2、佳佳乐在提供上述服务时，有权依据页面提示的相关业务收费标准收取运营服务费用。您存在未按时支付有关费用、不遵守佳佳乐有关业务规定或存在恶意操作、诋毁、损害佳佳乐声誉等情况的，佳佳乐有权单方终止对您提供服务，并保留追究您责任的权利。您利用佳佳乐系统从事违反国家法律法规活动的，佳佳乐将按照有权部门的要求停止为其办理业务。</p>
    <p>3、佳佳乐根据您的手机操作业务指令办理业务，对所有使用您账户账号、客户编号、密码及客户证书进行的操作均视为您所为，该操作所产生的电子信息记录均为佳佳乐处理业务的有效凭证。</p>
    <p>4、佳佳乐负责向您提供业务咨询服务，并在佳佳乐网站公布功能介绍、热点解答、平台规则等内容。佳佳乐具有对服务系统进行升级、改造的权利。</p>
    <p>5、佳佳乐在法律法规许可和您授权的范围内使用您的资料和操作记录。佳佳乐对您提供的申请资料和其他信息有保密的义务，但法律法规另有规定的除外。</p>
    <p>6、佳佳乐有义务在技术上确保手机软件和整个平台的正常运行，保证您操作的顺利。</p>
    <p>7、佳佳乐对 APP上的接入系统的安全、有效、实时性负责。但不承担因通讯故障等非主观因素所引起操作中断、操作错误引起的纠纷。</p>
    <p>8、佳佳乐有权根据具体情况增加、减少或撤销业务种类，也有权拒绝或取消不符合要求的您的使用资格，而无须预先通知客户。</p>
    <p>五、用户权利义务</p>
    <p>1、您确认并保证在注册时提供自己的真实资料, 并保证诸如手机号码、姓名、所在地区等内容的有效性及安全性,保证佳佳乐工作人员可以通过上述联系方式与您取得联系。同时, 您也有义务在相关资料实际变更时及时更新有关注册资料。</p>
    <p>2、您了解并同意，佳佳乐有权应政府部门（包括司法及行政部门）的要求，向其提供您在佳佳乐APP填写的注册信息和发布纪录等必要信息。</p>
    <p>3、在佳佳乐APP上使用佳佳乐APP服务过程中，您承诺遵守以下约定：</p>
    <p>1)在使用佳佳乐APP服务过程中实施的所有行为均遵守国家法律、法规等规范文件及佳佳乐APP各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议及相关规则。您如果违反前述承诺，产生任何法律后果的，您应以自己的名义独立承担所有的法律责任，并确保佳佳乐免于因此产生任何损失或增加费用。</p>
    <p>2)不发布国家禁止发布的信息（除非取得合法且足够的许可），不发布涉嫌侵犯他人知识产权或其它合法权益的信息，不发布违背社会公共利益或公共道德、公序良俗的信息，不发布其它涉嫌违法或违反本协议及各类规则的信息。</p>
    <p>3)不对佳佳乐APP上的任何数据作商业性利用，包括但不限于在未经佳佳乐事先书面同意的情况下，以复制、传播等任何方式使用佳佳乐APP站上展示的资料。</p>
    <p>4)不使用任何装置、软件或例行程序干预或试图干预佳佳乐APP的正常运作或正在佳佳乐APP上进行的任何活动。您不得采取任何将导致不合理的庞大数据负载加诸佳佳乐APP网络设备的行动。</p>
    <p>5）不得使用或盗用他人的银行卡及银行账户，若使用或盗用他人的银行卡及银行账户而完成的支付交易所产生的任何责任由用户自行承担。</p>
    <p>4、您了解并同意：</p>
    <p>1)您违反上述承诺时，佳佳乐有权依据本协议的约定，做出相应处理或终止向您提供服务，且无须征得您的同意或提前通知于您。</p>
    <p>2)根据相关法令的指定或者佳佳乐APP服务规则的判断，您的行为涉嫌违反法律法规的规定或违反本协议和/或规则的条款的，佳佳乐有权采取相应措施，包括但不限于直接屏蔽、删除侵权信息、降低您的信用值或直接停止提供服务。</p>
    <p>3)对于您在佳佳乐APP上实施的行为，包括您未在佳佳乐APP上实施但已经对佳佳乐APP及其用户产生影响的行为，佳佳乐有权单方认定您行为的性质及是否构成对本协议和/或规则的违反，并据此采取相应的处理措施。您应自行保存与您行为有关的全部证据，并应对无法提供充要证据承担不利后果。</p>
    <p>4)对于您涉嫌违反承诺的行为对任意第三方造成损害的，您均应当以自己的名义独立承担所有的法律责任，并应确保佳佳乐免于承担因此产生的损失或增加的费用。</p>
    <p>5)如您涉嫌违反有关法律或者本协议之规定，使佳佳乐遭受任何损失，或受到任何第三方的索赔，或受到任何行政管理部门的处罚，您应当赔偿佳佳乐因此造成的损失及（或）发生的费用，包括合理的律师费用。</p>
    <p>6)您在使用佳佳乐APP支付过程中，应确保银行卡或银行账户之真实、有效。若因银行卡或银行账户被取消、过期或账户余额不足而造成缴纳失败所产生的损失及后果，由用户负责。</p>
    <p>五、责任范围和责任限制</p>
    <p>1、您了解并同意，佳佳乐不对因下述任一情况而导致您的任何损害赔偿承担责任，包括但不限于利润、商誉、使用、数据等方面的损失或其它无形损失的损害赔偿：</p>
    <p>1)佳佳乐接收到的指令信息不明、存在乱码、不完整等。</p>
    <p>2)用户账户存款余额或信用额度不足。</p>
    <p>3)用户账户内资金被依法冻结或扣划。</p>
    <p>4)用户未能按照佳佳乐的有关业务规定正确操作。</p>
    <p>5)用户的行为出于欺诈或其他非法目的。</p>
    <p>6) 任何非因佳佳乐的原因而引起的与佳佳乐APP服务有关的其它损失。</p>
    <p>2、您同意在使用佳佳乐APP服务过程中显示佳佳乐自行或由第三方服务商向您发送或提供的推广或宣传信息、资讯、动态等（统称为推广信息，包括商业与非商业信息），其方式和范围可不经向您特别通知而变更。除法律法规明确规定外，您应自行对依该推广信息进行的操作审慎评估理性接受，并对操作后果负责，对用户因依该推广信息进行的操作或前述第三方服务商提供的内容因而遭受的损失或损害，佳佳乐不承担任何责任。</p>
    <p>3、佳佳乐对下列不可抗力行为免责：信息网络正常的设备维护，信息网络连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能服务或延迟服务。</p>
    <p>4、您应当严格遵守本协议及佳佳乐规则等，因您违反协议或规则的行为给第三方或佳佳乐造成损失的，您应当承担全部责任。</p>
    <p>5、佳佳乐保留在中华人民共和国大陆地区施行之法律允许的范围内独立决定拒绝服务、关闭用户账户、审查、编辑、清除用户发布内容或取消订单的权利。</p>
    <p>六、服务终止及中断</p>
    <p>1、您同意，佳佳乐基于APP服务的安全性，有权中止向您提供部分或全部佳佳乐APP服务，暂时冻结您的账户，待安全问题解决后及时恢复，并对中止、冻结及恢复的事实及时通知。如果APP的安全问题是由于您的违法行为引起，佳佳乐有权终止向您提供部分或全部佳佳乐APP服务，永久冻结（注销）您的帐户，并有权向您对损失进行索赔。</p>
    <p>2、您同意，您与佳佳乐的协议关系终止后，佳佳乐仍享有下列权利：</p>
    <p>1) 继续保存您未及时删除的注册信息及您使用佳佳乐APP服务期间发布的所有信息至法律规定的记录保存期满。</p>
    <p>2）您在使用佳佳乐APP服务期间存在违法行为或违反本协议和/或规则的行为的，佳佳乐仍可依据本协议向您主张权利、追究责任。</p>
    <p>3）佳佳乐不退回您已支付的服务费用。</p>
    <p>七、隐私权政策</p>
    <p>1、佳佳乐将在佳佳乐APP公布并不时修订隐私权条款，隐私权条款构成本协议的有效组成部分。</p>
    <p>2、您知悉并认可：佳佳乐可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与本网站同等的保护用户隐私的责任，则佳佳乐有权将用户的注册资料等提供给该第三方。另外，在不透露单个用户隐私资料的前提下，佳佳乐有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</p>
    <p>3、佳佳乐将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。对此您表示理解和认同。</p>
    <p>4、佳佳乐不会将您的个人信息转移或披露给任何非关联的第三方，除非：</p>
    <p>1）相关法律法规或法院、政府机关要求；</p>
    <p>2）为完成合并、分立、收购或资产转让而转移；</p>
    <p>3）为提供您要求的服务所必需；</p>
    <p>4）为您提供任何您可能感兴趣的信息或服务。</p>
    <p>5、您知悉并认可：佳佳乐通过推广或其他方式向您提供链接，使您可以接入第三方服务或网站。您使用该等第三方的服务时，须受该第三方的服务条款及隐私政策约束，您需要仔细阅读其条款。本协议仅适用于佳佳乐提供的服务器所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，佳佳乐对任何第三方使用由您提供的信息不承担任何责任。</p>
    <p>6、您知悉并认可：为保护您的个人信息的安全。我们使用各种安全技术和程序来保护您的个人信息不被未经授权的访问、使用或泄漏。对此您表示理解和认同。</p>
    <p>7、佳佳乐不对用户所发布信息的删除或储存失败负责。佳佳乐并不承诺对用户的存储信息进行无限期保留。</p>
    <p>八、知识产权声明</p>
    <p>1、佳佳乐APP所刊登的资料信息（包括但不限于编码、文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是佳佳乐或其内容提供者的财产，受中国和国际版权法的保护。本APP上所有内容的汇编是佳佳乐的排他财产，受中国和国际版权法的保护。本软件是佳佳乐或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。任何被授权的浏览、复制、打印和传播属于佳佳乐APP网站内信息内容都不得用于商业目的且所有信息内容及其任何部分的使用都必须包括此版权声明。</p>
    <p>2、用户通过佳佳乐APP发布的信息、文字、图片等资料均由佳佳乐用户提供，其真实性、准确性和合法性由信息发布人负责。佳佳乐不提供任何保证，并不承担任何法律责任。如果以上资料侵犯了第三方的知识产权或其他权利，责任由信息发布者本人承担，佳佳乐对此不承担责任。</p>
    <p>3、除法律另有强制性规定外，未经佳佳乐明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、传播、展示、镜像、上载、下载、转载、引用、链接、抓取或以其他方式使用佳佳乐APP的信息内容及相关资料，否则，佳佳乐有权追究其法律责任。</p>
    <p>4、佳佳乐APP以下内容不可任意转载：</p>
    <p>1）本APP内发布的所有信息；</p>
    <p>2）已作出不得转载或未经许可不得转载声明的内容；</p>
    <p>3）本APP中特有的图形、标志、页面风格、编排方式、程序等；</p>
    <p>4）本APP中必须具有特别授权或具有注册用户资格方可知晓的内容；</p>
    <p>5）其他法律不允许或本APP认为不适合转载的内容。</p>
    <p>10、对于不当引用佳佳乐网站内容而引起的纷争等或因纠纷等造成的任何损失，佳佳乐不承担相关法律责任。对不遵守本声明的用户或其他违法、恶意使用佳佳乐APP内容者，佳佳乐保留追究其法律责任的权利。</p>
    <p>11、佳佳乐APP相关声明版权及其修改权、更新权和法律允许范围内的最终解释权均属佳佳乐所有。</p>
    <p>九、法律适用、管辖与其他</p>
    <p> 1、本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国法律，如法律无相关规定的，则应参照通用国际商业惯例和（或）行业惯例。</p>
    <p>2、本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</p>
    <p>3、因本协议产生之争议、纠纷，应由佳佳乐与您友好协商解决；协商不成的，应提交北京仲裁委员会按照该会仲裁规则仲裁解决。</p>
    <img src="../../assets/img/backPic.png" @click="back" class="pic" v-if="entryMode">
  </div>
</template>

<script>
export default {
    data() {
      return {
        entryMode: "" //判断是怎么进来的
      }
    },
    created () {
      document.title = "用户服务协议"
      let entryMode = this.$route.query.entryMode;//判断来源
      if(!!entryMode){
        this.entryMode = entryMode;
      }
    },
    methods: {
      back() {
        if(this.entryMode == 'backs'){
          this.$router.push({
            name: "registForRedEnvelopes",
            query: {
              isBack: "0000",
              commendCode:this.$route.query.commendCode,
              activeCode:this.$route.query.activeCode
            }
          })
        }else{
          this.$router.push({
            name: "jftShare",
            query: {
              isBack: "0000"
            }
          })
        }
      }
    },
};
</script>

<style scoped>
.wrap{
    padding: 0 10px;
    padding-bottom: 20px;
}
.title{
    text-align: center;
    padding: 10px 0;
}
.weight {
  font-weight: bold;
}
p{
    line-height: 30px;
}
.subTitle{
    line-height: 28px;
    margin-top: 10px;
}
.pic{
    position: fixed;
    left: 0;
    bottom: 40%;
    opacity: .7;
}
</style>
